export default __webpack_public_path__ + "static/media/gallery - intro insult_01.3637e214.jpg";